// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2s4MA","itemTitle":"ClientEmergencyInfo_itemTitle__2j9jU","itemText":"ClientEmergencyInfo_itemText__1AAXE"};